var map = {
	"./50_jahre_frauenstimmrecht.jpg": 152,
	"./corina-gredig.png": 385,
	"./leonore-porchet.png": 386,
	"./marianne-binder-keller.png": 387,
	"./martina-bircher.png": 388,
	"./maya-riniker.png": 389,
	"./readme.md": 392,
	"./susanne-vincenz-stauffacher.png": 390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;